'use client';

import type { ReactNode } from 'react';
import { useMultistepForm } from '../../form-controls/MultistepForm/hooks/useMultistepForm';
import { GenericErrorStep } from '../../GenericErrorStep/GenericErrorStep';

type ErrorStepProps = {
  onRetry?: () => void | Promise<void>;
  onAction?: () => void | Promise<void>;
  actionHref?: string;
  errorMessage?: string;
  errorTitle?: string;
  actionText?: string;
  retryingText?: string;
  fallbackStep?: string;
  illustration?: ReactNode;
  actionButtonTrackName?: string;
  trackContainer?: string;
  titleTrackName?: string;
  descriptionTrackName?: string;
};

function ErrorStep({
  onRetry,
  onAction,
  actionHref,
  errorMessage,
  errorTitle,
  actionText,
  retryingText,
  fallbackStep,
  illustration,
  actionButtonTrackName,
  trackContainer,
  titleTrackName,
  descriptionTrackName,
}: ErrorStepProps) {
  const { skipToStep } = useMultistepForm();

  const handleAction = async () => {
    if (onAction) {
      await onAction();
      return;
    }

    if (onRetry) {
      await onRetry();
      return;
    }

    if (fallbackStep) {
      skipToStep(fallbackStep);
    }
  };

  return (
    <GenericErrorStep
      onAction={actionHref ? undefined : handleAction}
      actionHref={actionHref}
      errorTitle={errorTitle}
      errorMessage={errorMessage}
      actionText={actionText}
      retryingText={retryingText}
      illustration={illustration}
      actionButtonTrackName={actionButtonTrackName}
      trackContainer={trackContainer}
      titleTrackName={titleTrackName}
      descriptionTrackName={descriptionTrackName}
    />
  );
}

export { ErrorStep };
